import { logFormData } from 'shared/lib/logFormData';
import type { TFormAnalyticsEventsOverrides } from 'shared/types/TFormAnalyticsEventsOverrides';

import type { TAdditionalDataFormFields } from 'entities/creditForm';
import { setAdditionalInfo, sendStepsAnalyticsEvents } from 'entities/creditForm';

import { AdditionalInfoTexts } from 'features/UpdateAdditionalInfo';

export const submitAdditionalInfoForm =
  (actualData: TAdditionalDataFormFields, analyticsOverrides?: TFormAnalyticsEventsOverrides): ThunkResult<void> =>
  async (dispatch) => {
    logFormData('AdditionalInfo FormStep SubmitData', actualData);
    dispatch(sendStepsAnalyticsEvents([4], AdditionalInfoTexts, 'manual', analyticsOverrides));
    dispatch(setAdditionalInfo({ data: actualData }));
  };
